import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'planone-file-video-embed',
  templateUrl: './file-video-embed.component.html',
  styleUrls: ['./file-video-embed.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FileVideoEmbedComponent {
  @Input() index?: number;

  @Input() path: unknown = '';
  @Input() controls = true;

  @Input() width: unknown = '640';
  @Input() height: unknown = '360';
  @Input() frameborder: unknown = '0';
}
